import { render, staticRenderFns } from "./MessageAdd.vue?vue&type=template&id=642d0452&scoped=true"
import script from "./MessageAdd.vue?vue&type=script&lang=js"
export * from "./MessageAdd.vue?vue&type=script&lang=js"
import style0 from "./MessageAdd.vue?vue&type=style&index=0&id=642d0452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642d0452",
  null
  
)

export default component.exports